import { gql } from '@apollo/client'

import { BoxLockWithProvider } from './box-lock-with-provider'
import { PaywallProvider } from './components'
import { BoxPaywallProps } from './types'

export function BoxPaywall(props: BoxPaywallProps) {
  return (
    <PaywallProvider>
      <BoxLockWithProvider {...props} />
    </PaywallProvider>
  )
}

BoxPaywall.fragments = {
  viewer: gql`
    fragment BoxPaywall_viewer on Profile {
      pid
    }
  `,
}
